import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

import { helpDispatch, Tooltip, TooltipTypes } from 'components/admin/Help';
import {
  startEditLineItem,
  startAddLineItem
} from '../../../store/actions/invoices';

const styles = theme => ({
  root: {
  },
  width: {
    width: '300px',
  },
});

class InvoiceItem extends Component {
  constructor(props){
    super(props);
    this.state = {
      id: "",
      description: "",
      quantity: "",
      unitPrice: "",
    }
  }

  //TODO: only handle set state when nextProps changes
  componentWillReceiveProps(nextProps) {
    const lineItem = nextProps.lineItem;
    if (lineItem === undefined) {
      this.setState({
        id: "",
        description: "",
        quantity: "",
        unitPrice: ""
      })
    } else {
      this.setState({
        id: lineItem.id,
        description: lineItem.description,
        quantity: lineItem.quantity,
        unitPrice: lineItem.unitPrice
      });
    }
  }

  handleChange = propertyName => event => {
    this.setState({
      [propertyName]: event.target.value,
    });
  };

  render() {
    const {classes, invoice, lineItem, showItem, handleClose, startEditLineItem, startAddLineItem} = this.props;
    let title = "";
    if (showItem !== undefined) {
      title = showItem === "add" ? "Add Line Item" : "Edit Line Item";
    }

    return (
      <Dialog
        open={showItem !== undefined ? true : false}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle className={classes.width} id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            multiline={true}
            margin="dense"
            id="description"
            label="Description"
            type="text"
            value={this.state.description}
            onChange={this.handleChange("description")}
            fullWidth
          />
        </DialogContent>
        <DialogContent>
          <TextField
            margin="dense"
            id="quantity"
            label="Quantity"
            type="number"
            value={this.state.quantity}
            onChange={this.handleChange("quantity")}
            fullWidth
          />
        </DialogContent>
        <DialogContent>
          <TextField
            margin="dense"
            id="unitPrice"
            label="Unit Price"
            type="number"
            value={this.state.unitPrice}
            onChange={this.handleChange("unitPrice")}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose} >
            Cancel
          </Button>
          <Tooltip type={TooltipTypes.INVOICE_SAVE_ITEM} placement="right">
            <Button color="primary" onClick={() => {
                //TODO: refactor as this code sucks
                if (showItem === "add") {
                  const payload = {
                    description: this.state.description,
                    quantity: Number(this.state.quantity),
                    unitPrice: Number(this.state.unitPrice)
                  };
                  startAddLineItem(invoice.id, payload);
                } else {
                  const payload = {
                    description: this.state.description,
                    quantity: Number(this.state.quantity),
                    unitPrice: Number(this.state.unitPrice)
                  }
                  startEditLineItem(invoice.id, lineItem.id, payload);
                }
                this.setState({description: "", quantity: "", unitPrice: ""});
                helpDispatch();
                handleClose();
              }} >
              Save
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startEditLineItem: (invoiceID, lineItemID, updates) => dispatch(startEditLineItem(invoiceID, lineItemID, updates)),
  startAddLineItem: (invoiceID, lineItem) => dispatch(startAddLineItem(invoiceID, lineItem))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoiceItem);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoiceItem.jsx